import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { PATHS, NEXT_STATIC_IMAGES, NEW_TAB_ATTRIBUTES } from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import Button from 'src/common/components/ButtonDS22';
import styles from './PitchPageBrowseBoats.module.scss';

const PitchPageBrowseBoats: FC = () => {
  const [t] = useTranslation('pitch-page-browse-boats');

  return (
    <PitchPageLayout backgroundColor="midnight01">
      <div className={styles.root}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={`${NEXT_STATIC_IMAGES}pitch-pages-common/browse-boats.svg`}
          width={132}
          height={80}
          alt={t('title')}
          loading="lazy"
        />
        <div className={styles.title}>
          <Typography
            type="h3"
            size="display-5"
            sizeFromBreakpointM="display-4"
          >
            {t('title')}
          </Typography>
        </div>
        <Button
          type="link"
          href={PATHS.SEARCH}
          variant="primary-blue"
          fitWidth="m"
          {...NEW_TAB_ATTRIBUTES}
        >
          <Typography
            size="body-xl"
            type="p"
            weight="semibold"
          >
            {t('button')}
          </Typography>
        </Button>
      </div>
    </PitchPageLayout>
  );
};

export default PitchPageBrowseBoats;
